import type { ProtoAppearance, ProtoMatchGoals } from "@catbento/shared";
import type { CatalystSnapshot, RawPlayerRecord } from "./snapshot.js";

// Pure lookups for the matches group (Phase 02d). Grounded in
// renderers-matches.js: the Gantt rows come from player.appearances[], and the
// Team-Goals overlay indexes window.CatalystData.matchGoals by matchId.

type Players = Record<string, RawPlayerRecord>;

/**
 * A player's match appearances (the Gantt rows), or [] if the player is absent
 * or has none. Appearances are a flat array in the snapshot (no per-season
 * split — only the current season is captured), so there is no season argument.
 */
export function getMatches(players: Players, name: string): ProtoAppearance[] {
  return players[name]?.appearances ?? [];
}

/**
 * The goal-by-goal timelines, keyed by matchId (string keys, as in the JSON).
 * The Matches renderer indexes this by each appearance's matchId; returning the
 * whole map keeps that a plain lookup (and avoids calling a hook per match).
 */
export function getMatchGoalsMap(data: CatalystSnapshot): Record<string, ProtoMatchGoals> {
  return data.matchGoals ?? {};
}

/** One match's goal timeline, or null if not captured. */
export function getMatchGoals(
  data: CatalystSnapshot,
  matchId: number | string
): ProtoMatchGoals | null {
  return getMatchGoalsMap(data)[String(matchId)] ?? null;
}
